import { pushToDataLayer } from '../datalayer';

export const trackStoreFilter = ({
  isSelected,
  filterValue,
  searchType,
  searchTerm,
  filterGroup = 'on display - in store',
  filterName = 'undefined',
  filterType = 'checkbox',
}: {
  isSelected: boolean;
  filterValue: string;
  searchType?: string;
  searchTerm?: string;
  filterGroup?: string;
  filterName?: string;
  filterType?: string;
}) => {
  pushToDataLayer({
    event: isSelected ? 'select_filter' : 'unselect_filter',
    filter_group: filterGroup,
    filter_name: filterName,
    filter_type: filterType,
    filter_value: filterValue,
    search_type: searchType,
    search_term: searchTerm,
  });
};
